import { useEffect, useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { instanciaActual } from '@/lib/instancia';

/**
 * El sitio viejo (cuenta de carlos) ya no se usa: muestra esto y manda al nuevo.
 *
 * La migración se completó el 2026-09-18 — las 1.438 facturas están en la base
 * de la cuenta de BET y el delta final dio 0 cambios. Esta pantalla reemplaza a
 * TODAS las rutas de la instancia vieja (no sólo al login): quien tenía la
 * sesión abierta entra directo al tablero, y ahí es donde más importa que no
 * siga trabajando contra la base vieja.
 *
 * El destino es el `.pages.dev` del proyecto nuevo y no
 * `appfacturacion.betsupplier.co`, porque hoy ese dominio TODAVÍA sirve este
 * sitio: mandar ahí sería un loop. Cuando el dominio se mueva al proyecto
 * nuevo, este sitio queda sólo en `facturacion-web-46u.pages.dev` y la
 * redirección sigue siendo correcta.
 */
const SITIO_NUEVO = 'https://facturacion-web-d54.pages.dev';
const SEGUNDOS = 3;

/** `true` en la instancia vieja conocida. Un host desconocido NO redirige. */
export function debeMudarse(): boolean {
  const i = instanciaActual();
  return i.conocida && !i.esProduccion;
}

export function Mudanza() {
  const [quedan, setQuedan] = useState(SEGUNDOS);
  // Conserva la ruta: un link a /factura/<id> sigue abriendo esa factura, que
  // tiene el mismo id en la base nueva.
  const destino = SITIO_NUEVO + window.location.pathname + window.location.search;

  useEffect(() => {
    if (quedan <= 0) {
      window.location.replace(destino);
      return;
    }
    const t = setTimeout(() => setQuedan((n) => n - 1), 1000);
    return () => clearTimeout(t);
  }, [quedan, destino]);

  // Mismo estilo sobrio que tenía el login viejo: fondo gris claro y la tarjeta.
  return (
    <main className="flex min-h-screen items-center justify-center bg-gray-50 px-4 py-12">
      <Card className="w-full max-w-md">
        <CardContent className="pt-6 text-center">
          <h1 className="text-xl font-bold tracking-tight text-gray-900">
            Bet Supplier Facturación
          </h1>
          <p className="mt-4 text-sm text-gray-600" aria-live="polite">
            Lo llevamos en{' '}
            <span className="font-semibold text-gray-900 tabular-nums">
              {Math.max(quedan, 1)}
            </span>
            …
          </p>
          <div className="mx-auto mt-3 h-1 w-40 overflow-hidden rounded-full bg-gray-200">
            <div className="mudanza-barra h-full rounded-full bg-primary" />
          </div>
          <a
            href={destino}
            className="mt-4 inline-block py-2 text-sm font-medium text-amber-700 underline-offset-4 hover:underline"
          >
            ¿No lo llevó? Entre por acá
          </a>
        </CardContent>
      </Card>
    </main>
  );
}
